import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/orderPay.vue'
createPage(Page)